/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {lookupCustomer} from '../api'

export const useMutationLookupCustomer = createReactQueryMutationHook('lookupCustomer', lookupCustomer)
